export default __webpack_public_path__ + "static/Organograma12-b336768f8f0a57a67e9a5671ddd07ad4.png";